import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { GroupDto } from '@mondy/shared';
import { api } from '@/api';

interface CreateGroupResponse {
  group: GroupDto;
}

/**
 * Create a new group. Invalidates `['groups','my']` on success; the caller is
 * responsible for optionally setting the returned group as the active scope.
 */
export function useCreateGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) =>
      api.post<CreateGroupResponse>('/api/groups', { name }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['groups', 'my'] });
    },
  });
}
